import script from "./AppHeaderNeighborhoodList.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppHeaderNeighborhoodList.vue?vue&type=script&lang=ts&setup=true"

import "./AppHeaderNeighborhoodList.vue?vue&type=style&index=0&id=5a5d72e6&lang=scss"

const __exports__ = script;

export default __exports__